import React from "react";
import { Link } from "react-router-dom";
import { dateParts, isEventPast } from "../../utils/date";

const TournamentCard = ({ tournament, slug, color }) => {
    const { d, m } = dateParts(tournament.startDate);
    const cover = tournament.coverUrl || "/images/fotos/placeholder.svg";

    const effectiveSlug = slug || tournament.clientId?.slug;
    const href = effectiveSlug ? `/${effectiveSlug}/tournaments/${tournament._id}` : '#';

    const isPast = isEventPast(tournament.endDate || tournament.startDate);
    const year = new Date(tournament.startDate).getFullYear();

    return (
        <Link
            to={href}
            className={`group block bg-[#0D0D0D] border border-white/5 rounded-2xl overflow-hidden transition-all duration-300 hover:border-white/20 ${isPast ? 'opacity-60 grayscale-[0.5]' : ''}`}
        >
            <div className="relative aspect-video overflow-hidden border-b border-white/5">
                <img
                    src={cover}
                    alt={tournament.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                />
                {isPast ? (
                    <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
                        <span className="text-[10px] font-black uppercase tracking-[3px] text-white py-2 px-4 border border-white/20 rounded-lg backdrop-blur-sm">Finalizado</span>
                    </div>
                ) : (
                    <div className="absolute top-3 right-3 flex gap-2">
                        <span className="text-[10px] font-black uppercase tracking-[3px] text-white py-1 px-3 border border-white/20 rounded-full backdrop-blur-sm bg-black/40">Torneo</span>
                        <span className="text-[10px] font-black uppercase tracking-[3px] text-white py-1 px-3 border border-white/20 rounded-full backdrop-blur-sm bg-primary-orange/80">{tournament.sport}</span>
                    </div>
                )}
            </div>

            <div className="p-5">
                <p className="text-[11px] font-medium text-white/30 truncate mb-1.5">
                    {tournament.clientId?.nombre || "Cargando..."}
                </p>
                <h3 className="text-lg font-bold text-white leading-tight mb-6 line-clamp-1">
                    {tournament.name}
                </h3>

                <div className="grid grid-cols-2 gap-4 pt-4 border-t border-white/5 bg-white/[0.02] -mx-5 px-5 pb-5 rounded-b-2xl">
                    <div>
                        <p className="text-[10px] font-medium text-white/30 uppercase tracking-wider mb-1">Inscripción</p>
                        <p className="text-sm font-bold text-white">
                            {tournament.registrationFee > 0 ? `$${tournament.registrationFee.toLocaleString('es-AR')}` : 'GRATIS'}
                        </p>
                    </div>
                    <div className="text-left">
                        <p className="text-[10px] font-medium text-white/30 uppercase tracking-wider mb-1">Inicio</p>
                        <p className="text-xs font-bold text-white">
                            {d}/{m}/{year}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default TournamentCard;
